import request from '@host-panel/request';
import { TagsSpanScores } from '../../state/types';
import { stripPTag } from '../../utils/domUtils';

export type GetMessageTagsSpansResponse = {
  [vendor: string]: {
    span_scores: TagsSpanScores;
    hidden_span_scores: TagsSpanScores;
  };
};

export function getMessageTagsSpans(messageContent: string): Promise<GetMessageTagsSpansResponse> {
  return request(`/host-panel/message/analyze`, {
    method: 'POST',
    data: {
      content: stripPTag(messageContent)
    }
  });
}
